import { create } from "zustand";
import socket from "../Utils/socketClient";

export const useAuthStore = create<any>((set) => ({
  teamDetailsTrigger: false,
  selectedPlayerData: null,
  liveBidData: null,
  liveTeamId: null,
  liveCountdownRunning: false,
  liveCountdownOver: false,
  liveCountdownEndsAt: null,
  teamDetailsDivision: "men",

  triggerTeamDetailsUpdate: () => {
    const now = Date.now();
    socket.emit("teamDetailsTrigger", now);
    set({ teamDetailsTrigger: now });
  },

  setSelectedPlayerData: (playerData: any) => {
    socket.emit("selectedPlayerData", playerData);
    set({ selectedPlayerData: playerData });
  },

  clearSelectedPlayerData: () => {
    socket.emit("clearSelectedPlayerData");
    set({ selectedPlayerData: null });
  },

  sendLiveBidUpdate: (data: any) => {
    socket.emit("livePlayerBidUpdate", data);
    set({ liveBidData: data });
  },

  clearLiveBidData: () => {
    socket.emit("clearLiveBidData");
    set({ liveBidData: null });
  },

  // squad list
  sendLiveTeamId: (id: string) => {
    socket.emit("liveTeamDetails", id);
    set({ liveTeamId: id });
  },
  
  clearLiveTeamId: () => {
    socket.emit("clearLiveTeamId");
    socket.emit("clearLiveTeamDetails");
    socket.emit("liveTeamDetails", null);
    set({ liveTeamId: null });
  },

  startLiveCountdown: (durationMinutes = 1) => {
    const safeMinutes = Math.max(1, Number(durationMinutes) || 1);
    const endsAt = Date.now() + safeMinutes * 60 * 1000;
    socket.emit("startLiveCountdown", { endsAt, durationMinutes: safeMinutes });
    socket.emit("teamDetailsTrigger", {
      timeStamp: Date.now(),
      liveCountdownRunning: true,
      liveCountdownOver: false,
      liveCountdownEndsAt: endsAt,
    });
    set({
      liveCountdownRunning: true,
      liveCountdownOver: false,
      liveCountdownEndsAt: endsAt,
    });
  },

  closeLiveCountdown: () => {
    socket.emit("closeLiveCountdown");
    socket.emit("teamDetailsTrigger", {
      timeStamp: Date.now(),
      liveCountdownRunning: false,
      liveCountdownOver: false,
      liveCountdownEndsAt: null,
    });
    set({
      liveCountdownRunning: false,
      liveCountdownOver: false,
      liveCountdownEndsAt: null,
    });
  },

  markLiveCountdownOver: () => {
    socket.emit("liveCountdownOver");
    socket.emit("teamDetailsTrigger", {
      timeStamp: Date.now(),
      liveCountdownRunning: false,
      liveCountdownOver: true,
      liveCountdownEndsAt: null,
    });
    set({
      liveCountdownRunning: false,
      liveCountdownOver: true,
      liveCountdownEndsAt: null,
    });
  },

  setTeamDetailsDivision: (division: "men" | "women") => {
    socket.emit("teamDetailsDivision", division);
    set({ teamDetailsDivision: division });
  },

  clearTeamDetailsDivision: () => {
    socket.emit("clearTeamDetailsDivision");
    set({ teamDetailsDivision: "men" });
  },
}));
